import dayjs from 'dayjs';

/**
 * PTB-6415: "by <user> on <date>" attribution fragment (no leading verb).
 * Returns null when neither the user nor the timestamp is known so callers
 * can fall back to the bare status.
 */
export const formatAttribution = (
	by?: string | null,
	at?: string | null,
): string | null => {
	if (!by && !at) return null;
	const parts: string[] = [];
	if (by) parts.push(`by ${by}`);
	if (at) parts.push(`on ${dayjs(at).format('MM/DD/YY h:mm A')}`);
	return parts.join(' ');
};

/** "Completed by <user> on <date>" label for a finished hand check. */
export const formatHandCompletion = (
	completedBy?: string | null,
	completedAt?: string | null,
): string | null => {
	const attribution = formatAttribution(completedBy, completedAt);
	return attribution ? `Completed ${attribution}` : null;
};
